'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  /**
   * This needs `!important` as it shouldn't be overridden by hover state color.
   * And it can't be the default style as it should be overridden by inactive modifier.
   */
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.base.text + ' !important;\n  ';
  },
  inactive: function inactive(_ref2) {
    var theme = _ref2.theme;
    return '\n    color: ' + theme.colors.base.textLight + ';\n  ';
  }
};

var styles = '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  text-transform: capitalize;\n  transition: color 200ms ease;\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var OptionLabel = (0, _decisivUiUtils.buildStyledComponent)('OptionLabel', _styledComponents2.default.label, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

exports.default = OptionLabel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ButtonToggle/OptionLabel.js
// module id = 1556
// module chunks = 2